var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{attrs:{"type":"radio","id":_vm.inputId,"name":_vm.name},domProps:{"value":_vm.inputValue,"checked":_vm.value == _vm.inputValue},on:{"change":_vm.notifyUpdate}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.inputId}},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-445b12b7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/shared-components/radio-button/radio-button.html
// module id = null
// module chunks = 